import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';

import Theme, { ThemeType } from '../../theme';
import { isRequired, minLength3 } from '../../utils';
import { TextInput, LoadingModal, FormError } from '../../ui';
import { Button, Heading, HeadingTypes } from '../../components';

class SearchPartner extends PureComponent {
    onSubmit = async (values) => {
        const { partnerIdentifier } = values;
        this.partnerIdentifier.getRenderedComponent().blur();
        if (partnerIdentifier) {
            return this.props.onSearch(partnerIdentifier);
        }
    }

    render() {
        const { t, handleSubmit, isLoading, onSearchInputChange = () => { }, theme = ThemeType.dark,
            searchContainerStyle = {} } = this.props;
        const themeStyles = themeStyleMapper[theme]
        return (
            <View style={searchContainerStyle}>
                <Field
                    forwardRef
                    blurOnSubmit
                    showLabel={false}
                    name="partnerIdentifier"
                    placeholder={t('inviteSearchBy')}
                    component={TextInput}
                    returnKeyType="done"
                    autoCapitalize="none"
                    keyboardType="default"
                    validate={[isRequired, minLength3]}
                    onChange={onSearchInputChange}
                    onSubmitEditing={handleSubmit(this.onSubmit)}
                    ref={(ref) => { this.partnerIdentifier = ref; }}
                    icon={{
                        name: 'ios-search',
                        disabled: isLoading,
                        onPress: handleSubmit(this.onSubmit),
                    }}
                    inputHeight={50}
                    inputContainerStyle={themeStyles.containerStyle}
                    appliedInputStyle={themeStyles.inputStyle}
                    textInputStyle={themeStyles.textInput}
                    placeHolderTextStyle={theme === ThemeType.dark ? Theme.WHITE : Theme.GREY_MEDIUM}
                />
            </View>
        )
    }
}

SearchPartner.propTypes = {
    t: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    searchPartner: PropTypes.func.isRequired,
};

const themeStyleMapper = {
    [ThemeType.light]: {
        containerStyle: {
            backgroundColor: Theme.GREY_LIGHT,
        },
        textInput: {
            color: Theme.CHARCOAL,
        },
        inputStyle: {
            backgroundColor: 'red',
            color: Theme.CHARCOAL,
        },
    },
    [ThemeType.dark]: {
        containerStyle: {
            backgroundColor: '#585959'
        },
        textInput: {
            color: Theme.WHITE,
        },
        inputStyle: {
            backgroundColor: '#585959',
            color: Theme.WHITE,
        },
    },
};


const styles = StyleSheet.create({
    formLabel: {
        fontSize: 15,
        fontFamily: Theme.Custom600,
        paddingVertical: 5,
        color: Theme.GREY_MEDIUM,
    },
});


SearchPartner = reduxForm({ form: 'SearchPartnerForm' })(SearchPartner);
export default translate(['home'], { wait: true })(SearchPartner);
